import styled from 'styled-components';

import { BasicParagraph } from '../../../foundations/typefaces/BasicParagraph';
import style from '../../../style';
import type { Color } from '../../../style/types/theme';
import { Variant } from './types';

const getBorderColorByVariant = (variant: Variant, color: Color): string => {
  const colorsByVariant = {
    [Variant.INFO]: color.content.info.default(),
    [Variant.WARNING]: color.content.warning.default(),
    [Variant.ERROR]: color.content.error.default(),
    [Variant.SUCCESS]: color.content.success.default(),
  };

  return colorsByVariant[variant];
};

interface WrapperProps {
  $animationEnabled: boolean;
  $fadeIn: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color, size, transition }, $animationEnabled, $fadeIn }) => ({
    width: '100%',
    height: 'auto',
    backgroundColor: color.background.quaternary.default(),
    opacity: !$fadeIn || $animationEnabled ? 1 : 0,
    transform:
      !$fadeIn || $animationEnabled ? `translateY(0)` : `translateY(${size.units(-1.5)})`,
    transition: transition.standard('transform', 'opacity'),
  }),
);

interface FringeWrapperProps {
  $variant: Variant;
}

export const FringeWrapper = styled.div<FringeWrapperProps>(
  ({ theme: { color, size }, $variant }) => ({
    display: 'flex',
    gap: size.units(1),
    padding: size.units(2),
    borderLeft: `${size.units(1.5)} solid ${getBorderColorByVariant($variant, color)}`,
    alignItems: 'center',
  }),
);

export const RightComponent = styled.div({
  flexGrow: 1,
});
export const BottomComponent = styled.div({
  flexGrow: 1,
});

export const IconWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignSelf: 'flex-start',
  paddingTop: size.units(0.2),
}));

export const StyledBasicParagraph = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
  cursor: 'default',

  ...style.mixins.increaseSpecificity({
    a: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
}));

export const Content = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  gap: size.units(1),
}));

export const CenterWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
}));
